import { App } from 'vue';
import { PhotonService } from './services/photon.service';

export default {
    install(app: App) {
        app.config.globalProperties.$photonService = PhotonService.getInstance();
    }
}